import { ErrorPage } from "@cupcodev/ui";
import { useI18n } from "../i18n/I18nProvider";

export const NotFoundPage = () => {
  const { t } = useI18n();
  return (
    <ErrorPage
      code="404"
      title={t("errors.notFound.title")}
      description={t("errors.notFound.body")}
      actionLabel={t("errors.notFound.back")}
      actionHref="/"
    />
  );
};
